




















































import Vue from "vue";

export default Vue.extend({
  data() {
    return {
      mediaList: false,
      hierarchyList: false,
      mainmenuitem: "",
    };
  },

  watch: {
    $route: {
      handler: function (route) {
        this.handleSubMenuSelection(route);
      },
      deep: true,
      immediate: true,
    },
  },

  methods: {
    handleSubMenuSelection(menuitem: any): void {
      switch (menuitem.name) {
        case "photos":
        case "videos":
          this.mainmenuitem = "media";
          break;
        case "adminPanel":
        case "worldHeirarchy":
        case "nationalHeirarchy":
        case "nationalRepresentatives":
          this.mainmenuitem = "hierarchy";
          break;
        default:
          this.mainmenuitem = menuitem.name ? menuitem.name : "";
          break;
      }
    },
  },
});
